module.exports = __webpack_public_path__ + "img/art2-img3.cc58bf84.jpeg";